module.exports = __webpack_public_path__ + "static/cercazone_nordest3-08e00bdcff451e954367a92d790804c8.jpg";